import { RouteConfig } from 'vue-router';
import localizationFactory from '@/router/modules/localization-factory';

export default Array<RouteConfig>(
	{
		name: 'TransactionsHistory',
		path: '/',
		component: () => import('@/views/TransactionHistory/TransactionsHistory.vue'),
		meta: {
			layout: 'main',
			className: 'header-exchange-rates'
		},
		children: [
			{
				name: 'TransactionsHistory',
				path: '/',
				component: () => import('@/feature/TrHistory/views/TrAccountHistory.vue'),
			},
			{
				name: 'TransactionsRegisterHistory',
				path: 'register-history',
				component: () => import('@/feature/TrHistory/views/TrRegisterHistory.vue'),
			},
			{
				name: 'TrRegisterHistoryInfo',
				path: 'register-history-info/:registerId',
				component: () => import('@/feature/TrHistory/views/TrRegisterHistoryInfo.vue'),
				meta: localizationFactory('home.payment.register', {}),
			},
			{
				name: 'TransactionsPayrollHistory',
				path: 'salary-statements',
				component: () => import('@/feature/TrHistory/views/TrPayrollHistory.vue'),
			},
			{
				name: 'TrPayrollHistoryInfo',
				path: 'salary-statements-info/:id',
				component: () => import('@/feature/TrHistory/views/TrAccountHistoryInfo.vue'),
				meta: localizationFactory('payroll.downloadPayroll.title', {}),
			},
			{
				name: 'TransactionsSwiftHistory',
				path: 'swift-transfers',
				component: () => import('@/feature/TrHistory/views/TrSwiftHistory.vue'),
			},
			{
				name: 'TransactionsCurrencyHistory',
				path: 'currency-transfers',
				component: () => import('@/feature/TrHistory/views/TrCurrencyHistory.vue'),
			}
		]
	}
)
